import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../store/slices/authSlice";
import logoImg from "../assets/csir_logo.png";

export default function AdminNavbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/login");
  };

  return (
    <Navbar>
      <BrandContainer onClick={() => navigate("/admin")}>
        <Logo src={logoImg} alt="Logo" />
        <Brand>SolarAIDD</Brand>
        <Badge>Admin</Badge>
      </BrandContainer>
      <NavLinks>
        <NavLink onClick={() => navigate("/admin")}>Dashboard</NavLink>
        <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
      </NavLinks>
    </Navbar>
  );
}

// ----- Styled Components -----
const Navbar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: rgba(41, 52, 57, 0.95);
  backdrop-filter: blur(6px);
  color: white;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
`;

const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
`;

const Logo = styled.img`
  width: 133px;
  height: 45px;
  margin-right: 0.5rem;
`;

const Brand = styled.div`
  font-size: 1.5rem;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Badge = styled.span`
  background: #e55b41;
  padding: 0.2rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  @media (max-width: 768px) {
    gap: 0.8rem;
  }
`;

const NavLink = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background 0.3s ease;

  &:hover {
    background: #e55b41;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.3rem 0.6rem;
  }
`;

const LogoutButton = styled(NavLink)`
  background: rgba(255, 77, 79, 0.2);
  border: 1px solid #ff4d4f;
  color: #ff4d4f;

  &:hover {
    background: #ff4d4f;
    color: white;
  }
`;